export const SET_CURRENT_SEARCH_FOOD_PAGE = "SET_CURRENT_SEARCH_FOOD_PAGE";
export const ADD_SEARCH_FOOD_PAGE = "ADD_SEARCH_FOOD_PAGE";
export const REMOVE_SEARCH_FOOD_PAGE = "REMOVE_SEARCH_FOOD_PAGE";
export const RESET_SEARCH_FOOD_PAGES = "RESET_SEARCH_FOOD_PAGES";
